import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { OpportunityUserView } from '@api-proxies';
import { OpportunityCalendarEvent } from '@models/enums/OpportunityCalendarEvent';
import { BadgeComponent, icons, IconSanitizerService } from 'ngx-lib';
import { PopupCardBaseLayoutComponent } from '../../popup-card-base-layout/popup-card-base-layout.component';
import { UserInfoComponent } from '../../user-info/user-info.component';

export interface IOpportunityCardDetails {
    id?: number;
    name?: string;
    contactInfo?: string;
    eventDate?: Date;
    code?: string;
    opportunityStatusName?: string;
    companyName?: string;
    opportunityValue?: number;
    eventType?: number;
    opportunityUsers?: OpportunityUserView[];
    latitude?: number;
    longitude?: number;
}

@Component({
    selector: 'app-opportunity-card-expanded',
    templateUrl: './opportunity-card-expanded.component.html',
    styleUrls: ['./opportunity-card-expanded.component.scss'],
    imports: [CommonModule, BadgeComponent, PopupCardBaseLayoutComponent, UserInfoComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        'animate.enter': 'card-enter',
        'animate.leave': 'card-leave'
    }
})
export class OpportunityCardExpandedComponent {
    @Input()
    data?: IOpportunityCardDetails;

    @Input()
    hasBorder: boolean;

    @Input()
    showEventInfo?: boolean;

    @Input()
    allowCloseCard?: boolean;

    @Output()
    closeClicked: EventEmitter<void>;

    @Output()
    goToClicked: EventEmitter<void>;

    closeIcon?: SafeHtml;

    dueDatetype?: OpportunityCalendarEvent;
    followUpType?: OpportunityCalendarEvent;

    readonly icons = icons;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.closeIcon = this.iconSanitizer.getIcon('close');
        this.showEventInfo = true;
        this.hasBorder = true;
        this.allowCloseCard = true;
        this.dueDatetype = OpportunityCalendarEvent.DueDate;
        this.followUpType = OpportunityCalendarEvent.FollowUpContactDate;
        this.closeClicked = new EventEmitter<void>();
        this.goToClicked = new EventEmitter<void>();
    }

    onCloseClicked(): void {
        this.closeClicked.emit();
    }

    onGoToClicked(): void {
        this.goToClicked.emit();
    }
}
